import React from 'react';
import PropTypes from 'prop-types';
import { MenuItem } from 'react-bootstrap';
import ReactGA from 'react-ga';

import LoadingComponent from '../../core/LoadingComponent/LoadingComponent';
import GridContainer from '../../../containers/GridContainer';
import ModalComponent from '../../core/ModalComponent/ModalComponent';
import TeamMemberContainer from '../../../containers/TeamMemberContainer';
import TooltipComponent from '../../core/TooltipComponent/TooltipComponent';
import ROLES from '../TeamMember/TeamMemberConstants';
import DropDownComponent from '../../core/DropDownComponent/DropDownComponent';
import { MEMBERS_MENU, MEMBERS_MENU_INVITATION } from '../../core/MenuComponent/MenuConstants';
import FieldGroupComponent from '../../core/FieldGroupComponent/FieldGroupComponent';

import { HOME_PATH } from '../../../constants/routes';

import './teamMembers.scss';

const _ = require('lodash');

const ACTIONS = {
    add: 'add',
    update: 'update',
    delete: 'delete',
};

export const getTooltip = (container) => <TooltipComponent
    container={container}
    overlayContent={<span>
        <b>Members can:</b>
        <ol>
            {ROLES.member.map((permission, index) => <li key={index}>{permission}</li>)}
        </ol>
        <b>Admin users can:</b>
        <ol>
            {ROLES.admin.map((permission, index) => <li key={index}>{permission}</li>)}
        </ol>
    </span>}
    children={<span className='info-icon-members' />}
    className={'members-tooltip'}
/>;

class TeamMembersComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            modalTitle: '',
            modalBody: '',
            modalConfirmButtonTitle: 'Yes',
            modalOnConfirm: () => {},
            showModal: false,
            showAllMembersLink: true,
            members: [],
            nullUser: true,
        };

        this.GRID_PROPS = {};

        this.setGridProps(props);
    }

    componentDidUpdate() {
        if (this.state.nullUser && this.props.user && this.props.user.uid) {
            this.setGridProps(this.props);
        }
    }

    setGridProps = (props) => {
        if (this.state.nullUser && this.props.user && this.props.user.uid) {
            this.setState({
                nullUser: false,
            });
        }
        this.GRID_PROPS = [
            {
                id: 'member-icon',
                title: 'Member',
                className: 'member-icon',
                getter: () => {
                    return <div className='member-icon-container'>
                        <span />
                    </div>
                },
            },
            {
                title: 'Name',
                className: 'name',
                getter: (item) => <div className='licenses-team-members'>
                    {item.firstName} {item.lastName} {props.user.uid === item.uid && <span> (me)</span>}
                    {item.companies[this.props.currentCompanyId] && (item.companies[this.props.currentCompanyId].status === 'Pending' ? <p className='pending'>Pending</p>
                        : item.companies[this.props.currentCompanyId].isAdmin ? <p>Admin</p> : <p>Member</p>) }
                </div>,
            },
            {
                id: 'email',
                title: 'Email',
                className: 'email',
            },
            /*{
                id: 'role',
                title: () => <div>Role {getTooltip()}</div>,
                className: 'role',
            },
            {
                title: 'Status',
                className: 'status',
                getter: (member) => {
                    const isPending = member.status === 'Pending'
                    return <div className={isPending ? 'pending' : ''}>
                        {member.status}
                        {isPending && <Image
                            src={EMAIL_ICON}
                            onClick={() => {
                                const gridWidth = document.getElementById('team-members').offsetWidth;
                                const firstColumnWidth = document.getElementsByClassName('name')[0].offsetWidth;
                                const lastColumnWidth = document.getElementsByClassName('ellipsis')[0].offsetWidth;
                                const notificationElement = document.getElementById(`resendEmailSection-${member.uid}`);

                                notificationElement.style.width = `${gridWidth - firstColumnWidth}px`;
                                notificationElement.style.left = `-${gridWidth - firstColumnWidth - lastColumnWidth}px`;
                                notificationElement.classList.add('active');
                            }}
                        />}
                    </div>
                },
            },
            {
                title: 'Edit',
                className: 'buttons',
                getter: (member) => <div>
                    <div>
                        {props.user.uid !== member.uid && <Button
                            className="edit"
                            onClick={() => this.showModal(ACTIONS.update, member)}
                        />}
                        {props.user.uid !== member.uid && <Button
                            className="remove"
                            onClick={() => this.showModal(ACTIONS.delete, member)}
                        />}
                    </div>
                    <div id={`resendEmailSection-${member.uid}`} className="notification">
                        <div className="notification-panel">
                            <Image src={WARNING_ICON} />
                            <div className="text">
                                <span>Would you like to resend the invitation email?</span>
                            </div>
                            <div className="buttons">
                                <Button
                                    className="edit"
                                    onClick={async () => {
                                        await props.resendInvitation(member.uid);
                                        this.removeNotificationElement(member);
                                    }}
                                >Resend</Button>
                                <Button
                                    className="remove"
                                    onClick={() => this.removeNotificationElement(member)}
                                >Cancel</Button>
                            </div>
                        </div>
                    </div>
                </div>,
            },*/
            {
                title: 'Ellipsis',
                className: 'ellipsis',
                getter: (member) => {
                    const items = [];
                    let TEAMMEMBER_ACTION = {};
                    const isPending = member.companies[this.props.currentCompanyId] ? member.companies[this.props.currentCompanyId].status === 'Pending' : false;
                    const isloggedInUser = props.user.uid === member.uid;

                    const displayEllipsis = (!isloggedInUser && this.props.isUserAdmin) || (!isloggedInUser && isPending);
                    if (isPending && this.props.isUserAdmin) {
                        TEAMMEMBER_ACTION = {
                            ...MEMBERS_MENU,
                            ...MEMBERS_MENU_INVITATION,
                        };
                    } else if (isPending && !this.props.isUserAdmin) {
                        TEAMMEMBER_ACTION = {
                            ...MEMBERS_MENU_INVITATION,
                        };
                    } else {
                        TEAMMEMBER_ACTION = {
                            ...MEMBERS_MENU,
                        };
                    }

                    Object.keys(TEAMMEMBER_ACTION).forEach((path) => {
                        const { title, action } = TEAMMEMBER_ACTION[path];

                        items.push({
                            title,
                            action,
                        });
                    });
                    return <div>
                        { displayEllipsis && <DropDownComponent
                            eventKey={1}
                            className='member-dropdown'
                            title={<span className="ellipsis-span" />} id='members-menu'>
                            {items.map(({title, action}, index) =>
                                <MenuItem className={action}
                                    key={index}
                                    eventKey={title}
                                    onSelect={() => this.memberAction(action, member)}
                                >{title}</MenuItem>
                            )}
                        </DropDownComponent> }
                    </div>;
                },
            },
        ];
    }

    removeNotificationElement = ({ uid }) => {
        const notificationElement = document.getElementById(
            `resendEmailSection-${uid}`
        );

        notificationElement.style.left = '220px';
    }

    componentWillMount() {
        const { getMembers, isLoading, currentCompanyId, history } = this.props;

        if (!currentCompanyId) {
            return history.push(HOME_PATH);
        }

        if (!isLoading) {
            getMembers();
        }
    }

    showModal = (action, member) => {
        let state = {};
        const { currentCompanyId } = this.props;

        ReactGA.event({
            category: 'TeamMembers Component',
            action: 'Clicked Add Icon',
            label: 'Icon',
        });

        if (action === ACTIONS.delete) {
            const { removeMember } = this.props;

            state = {
                modalTitle: 'Delete Team Member?',
                modalBody: `Are you sure you want to delete ${member.firstName} ${member.lastName} ?`,
                modalConfirmButtonTitle: 'Delete',
                modalOnConfirm: () => {
                    member.currentCompanyId = currentCompanyId;
                    removeMember(member);

                    this.closeModal();
                },
                disableConfirmButton: false,
            };
        } else if (action === ACTIONS.add) {
            state = {
                modalTitle: `${_.capitalize(action)} Team Member`,
                modalBody: this.renderCreateForm(member),
                modalConfirmButtonTitle: 'Create',
                modalOnConfirm: this.props.submitMemberForm,
                disableConfirmButton: true,
            };
        } else {
            state = {
                modalTitle: `${_.capitalize(action)} Team Member`,
                modalBody: this.renderCreateForm(member),
                modalConfirmButtonTitle: `${_.capitalize(action)}`,
                modalOnConfirm: this.props.submitMemberForm,
                disableConfirmButton: true,
            };
        }

        this.setState({
            ...state,
            showModal: true,
        });
    }

    updateInvalid = (invalid) => {
        this.setState({
            disableConfirmButton: invalid,
        });
    }

    closeModal = () => {
        ReactGA.event({
            category: 'TeamMembers Component',
            action: 'Clicked Close Modal Icon',
            label: 'Icon',
        });

        this.setState({
            showModal: false,
        });
    }

    memberAction = (action, member) => {
        const { currentCompanyId } = this.props;
        if (action === 'resend_invitation') {
            this.props.resendInvitation(member.uid, currentCompanyId);
        } else {
            this.showModal(action, member);
        }
    }

    renderCreateForm = (member) => <TeamMemberContainer
        companyId={this.props.currentCompanyId}
        member={member}
        close={this.closeModal}
        updateInvalid={this.updateInvalid}
    />;

    showHideMembers = () => {
        this.setState({
            showAllMembersLink: !this.state.showAllMembersLink,
        });
    }

    handleSearchText = (event) => {
        let updatedList = this.props.members;
        let getCurrentCompanyId = this.props.currentCompanyId;
        updatedList = updatedList.filter(function (item) {
            let getUserRole = item.companies[getCurrentCompanyId].isAdmin ? 'Admin' : 'Member';
            let getUserStatus = item.companies[getCurrentCompanyId].status === 'Pending' ? 'Pending' : 'Active';
            return item.firstName.toLowerCase().search(event.target.value.toLowerCase()) !== -1 ||
            item.lastName.toLowerCase().search(event.target.value.toLowerCase()) !== -1 ||
            item.email.toLowerCase().search(event.target.value.toLowerCase()) !== -1 ||
            getUserRole.toLowerCase().search(event.target.value.toLowerCase()) !== -1 ||
            getUserStatus.toLowerCase().search(event.target.value.toLowerCase()) !== -1;
        });
        this.setState({ members: updatedList });
    };

    componentWillReceiveProps (nextProps) {
        if (!_.isEqual(nextProps.members, this.state.members)) {
            this.setState({
                members: nextProps.members,
            });
        }
        //empty search field
        if (document.getElementsByName('search')[0]) {
            document.getElementsByName('search')[0].value = '';
        }
    }

    render() {
        const { isLoading, isUserAdmin } = this.props;
        const {
            showModal,
            modalTitle,
            modalBody,
            modalConfirmButtonTitle,
            modalOnConfirm,
            disableConfirmButton,
            showAllMembersLink,
            members,
        } = this.state;

        return <div className="team-members">
            {isLoading && <LoadingComponent fullScreen />}
            <div className="members-header">
                <h3>Members</h3>
                { isUserAdmin && <div className="link">
                    <div className="add-members">
                        <a onClick={() => this.showModal(ACTIONS.add)}>
                            Add
                        </a>
                    </div>
                </div> }
            </div>
            <div className="search-members">
                <FieldGroupComponent
                    name="search"
                    type="search"
                    placeholder="Search"
                    onChange={this.handleSearchText}
                />
            </div>

            { members.length > 0 && <div>
                { showAllMembersLink && <GridContainer
                    name="team-members"
                    gridProps={this.GRID_PROPS}
                    items={members}
                    enablePagination
                    itemsPerPage={4}
                    sortBy={['firstName', 'lastName']}
                /> }
                { !showAllMembersLink && <GridContainer
                    name="team-members"
                    gridProps={this.GRID_PROPS}
                    items={members}
                    enablePagination
                    itemsPerPage={members.length}
                    sortBy={['firstName', 'lastName']}
                /> }
                { members.length > 4 && <div className={showAllMembersLink ? 'displayLink' : 'hideLink'}>
                    <a onClick={() => this.showHideMembers()}>
                        { showAllMembersLink ? 'Show all ' + members.length + ' Members'
                            : 'Hide Members' }
                    </a>
                </div> }
            </div>}
            <ModalComponent
                dialogClassName="team-members"
                show={showModal}
                handleClose={this.closeModal}
                title={modalTitle}
                body={modalBody}
                cancelButtonTitle="Cancel"
                confirmButtonTitle={modalConfirmButtonTitle}
                onConfirm={modalOnConfirm}
                disableConfirmButton={disableConfirmButton}
            />
        </div>;
    }
}

TeamMembersComponent.propTypes = {
    getMembers: PropTypes.func.isRequired,
    removeMember: PropTypes.func.isRequired,
    currentCompanyId: PropTypes.string,
    submitMemberForm: PropTypes.func.isRequired,
    isLoading: PropTypes.bool,
    members: PropTypes.array.isRequired,
    history: PropTypes.object.isRequired,
    resendInvitation: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
    isUserAdmin: PropTypes.bool,
};

export default TeamMembersComponent;



// WEBPACK FOOTER //
// ./src/components/profile/TeamMembers/TeamMembersComponent.js